import React from 'react'
import Link from 'gatsby-link'
import styles from './CountryDetails.module.scss'

const CountryDetails = props => (
	<div className={styles.Details__Wrapper} ref={props.callbackRef}>
		<div
			className={`${styles.Details} ${
				props.showCountryDetails ? '' : styles.Details__Hide
			}`}
		>
			<div className={styles.Details__Box}>
				<img src={props.locationMap.file.url} alt={props.locationMap.title} />
				<div className={styles.Details__Box__Items}>
					<div>
						<p>Language Spoken:</p>
						<p>{props.language}</p>
					</div>
					<div>
						<p>Time Zone:</p>
						<p>{props.timeZone}</p>
					</div>
					<div>
						<p>Currency:</p>
						<p>{props.currency}</p>
					</div>
					<div>
						<p>Apprenticeships:</p>
						<p>
							{props.apprenticeships.map((app, i) => (
								<span key={i}>
									{app}
									{i == props.apprenticeships.length - 1 ? '' : ', '}
								</span>
							))}
						</p>
					</div>
				</div>
			</div>
			<Link className="button" to="/interest-form/">
				Learn More
			</Link>
		</div>
	</div>
)

export default CountryDetails



// WEBPACK FOOTER //
// ./src/components/Destination/CountryDetails/index.js